import { render, staticRenderFns } from "./loadingCourses.vue?vue&type=template&id=36355e9a&scoped=true"
import script from "./loadingCourses.vue?vue&type=script&lang=js"
export * from "./loadingCourses.vue?vue&type=script&lang=js"
import style0 from "./loadingCourses.vue?vue&type=style&index=0&id=36355e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36355e9a",
  null
  
)

export default component.exports